/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Template_StarterInputs */



/**
* | output |
* | --- |
* | "Starter Format" |
*
* @param {Ccsl_Export_Template_StarterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_template_starter = /** @type {((inputs?: Ccsl_Export_Template_StarterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Template_StarterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Format debutant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Starterformat")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formato di partenza")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начальный формат")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato de inicio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("入门格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スターターフォーマット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टार्टर प्रारूप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formato inicial")
	return /** @type {LocalizedString} */ ("Starter Format")
});